import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
  COLOR,
  FONT_SIZE,
  FONT_WEIGHT,
  BREAKPOINTS,
} from '@ordermentum/ui-constants';

type FieldProps = {
  isEditing?: boolean;
  stacked?: boolean;
};

export const Field = styled('div')<FieldProps>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: ${p => (p.stacked ? '-0.66rem' : '0')};
  overflow-wrap: break-word;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.TABLET_MIN}) {
    flex-direction: ${p => (p.stacked ? 'column' : 'row')};
  }

  label {
    flex: ${p => (p.stacked ? '0 0 auto' : undefined)};
    padding-bottom: ${p => (p.stacked ? '0.5rem' : undefined)};
  }

  input[type='text'],
  input[type='number'],
  input[type='password'],
  input.form-control {
    // date picker overrides
    color: ${COLOR.GRAY_600};
    font-size: ${FONT_SIZE.SM};
    font-weight: ${FONT_WEIGHT.NORMAL};
    max-width: 100%;
    width: 100%;
  }

  input:disabled,
  input.form-control:disabled {
    color: ${COLOR.GRAY_500};
  }

  .rc__wrapper {
    max-width: 100%;
    width: 100%;
  }

  a {
    color: ${COLOR.BRAND_500};
    font-weight: ${FONT_WEIGHT.NORMAL};
  }
`;

export const FieldBody = styled('div')<FieldProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: ${p => (p.isEditing ? 'visible' : 'hidden')};
  justify-content: start;

  @media (min-width: ${BREAKPOINTS.TABLET_MIN}) {
    padding-left: ${p => (p.stacked ? 0 : '0.5rem')};
  }
`;

type LabelProps = {
  stacked?: boolean;
  width?: string;
};

export const labelStyles = (props: LabelProps) => css`
  color: ${COLOR.GRAY_500};
  cursor: default;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: nowrap;
  font-size: ${FONT_SIZE.BASE};
  font-weight: ${FONT_WEIGHT.NORMAL};
  padding: 0.5rem 0;

  a {
    margin-top: 1.25rem;
  }

  @media (min-width: ${BREAKPOINTS.TABLET_MIN}) {
    flex: ${props.width ? `0 0 ${props.width}` : `0 0 130px`};
  }
`;

type TextProps = {
  wrapped?: boolean;
};
export const Text = styled('div')<TextProps>`
  color: ${COLOR.GRAY_600};
  flex: 1;
  font-size: ${FONT_SIZE.BASE};
  font-weight: ${FONT_WEIGHT.LIGHT};
  padding-top: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: ${p => (p.wrapped ? 'wrap' : 'nowrap')};
`;
